export const BULK_ACTIONS_API_END_POINT = {
  INITIATE_BULK_ACTION: "host/initiate/bulk/action",
  PERFORM_BULK_ACTION: "host/perform/bulk/action",
};
